<template>
    <CContainer class="align-items-center">
        <CCol sm="6">
            <CCard>
                <CCardHeader>
                    <strong>{{ user.vorname }} {{ user.nachname }}  </strong><small>bearbeiten</small>
                </CCardHeader>
                <CCardBody>
                    <CInput
                            label="Vorname"
                            v-model="user.vorname"
                            placeholder="Nachname"
                    />
                    <CInput
                            label="Nachname"
                            placeholder="Nachname"
                            v-model="user.nachname"
                    />
                </CCardBody>
                <CCardFooter>
                    <CRow>
                        <CCol sm="6">
                            <CButton type="submit" @click="updateCurrentUser(user.id)" size="sm" color="success"><CIcon name="cil-check-circle"/> Speichern</CButton>
                        </CCol>
                    </CRow>
                </CCardFooter>
            </CCard>
        </CCol>
    </CContainer>
</template>

<script>

    import { mapActions, mapGetters } from 'vuex'

    export default {
        name: "Edit",
        data: ()=>({
            title: '',
            text: '',
            color: '',
            modal: false
        }),

        methods: {
            ...mapActions('user', [
                'updateUser'
            ]),

            updateCurrentUser(id) {

                let data = {
                    url: this.shop.apiUrl,
                    client: this.shop.clientId,
                    secret: this.shop.clientSecret,
                    name: this.shop.name,
                    id: id
                }

                this.updateShop(data).then(res => {
                    if(this.getUpdateStatus) {
                        this.$router.push('/dashboard/shops/list')
                    }
                })
            }
        },

        computed: {
            ...mapGetters('user', ['getUserById']),
            user () {
               return this.getUserById(this.$route.params.id)
            }
        }
    }
</script>

<style scoped>

</style>
